import React from 'react';
import { siteConfig } from '../data';
import { ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';

const Hero = () => {
  return (
    <section className="relative min-h-[50vh] md:min-h-[60vh] lg:min-h-[70vh] flex items-center pt-32 pb-12 overflow-hidden bg-orange-50/50">
      {/* Background Image with Overlay */}
      <motion.div 
        initial={{ scale: 1.05, opacity: 0 }}
        animate={{ scale: 1, opacity: 0.4 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
        className="absolute inset-0 z-0"
      >
        <img
          src={siteConfig.images.hero}
          alt="Integrativ Massageterapi atmosfære"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-orange-50/70"></div>
      </motion.div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="max-w-2xl"
        >
          <div className="inline-flex items-center mb-8 px-4 py-1.5 bg-stone-200/50 border border-stone-300/50 rounded-full">
            <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-stone-600">
              RAB-registreret behandler
            </span>
          </div>
          
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-light text-stone-900 leading-tight mb-8">
            Massage & Massageterapi <br className="hidden md:block" /> 
            <span className="text-xl md:text-2xl text-stone-500 italic block mt-2">på Nørrebro, København</span>
          </h1>
          
          <div className="text-lg md:text-xl text-stone-700 font-light leading-relaxed mb-10 max-w-xl space-y-4">
            <p>Behandling, forebyggelse, smertelindring.</p>
            <p>Massageterapi, der understøtter din krops naturlige helingsprocesser for en varigt bedre funktion.</p>
          </div>
          
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-6">
            <a
              href={siteConfig.bookingUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-[#b8a58d] text-stone-50 px-8 py-4 text-sm tracking-widest uppercase hover:bg-[#a6947e] transition-all duration-300 flex items-center justify-center group"
            >
              Book din behandling
              <ArrowRight className="ml-2 w-4 h-4 transition-transform group-hover:translate-x-1" />
            </a>
            <a
              href="#behandling"
              className="px-8 py-4 text-sm tracking-widest uppercase border border-stone-300 text-stone-700 hover:bg-stone-200/50 transition-all duration-300 flex items-center justify-center"
            >
              Læs om behandlingen
            </a>
          </div>
        </motion.div>
      </div>

      {/* Decorative element */}
      <motion.div 
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 1 }}
        className="absolute bottom-10 right-10 hidden lg:block"
      >
        <div className="flex items-center space-x-4 transform rotate-90 origin-right">
          <span className="h-[1px] w-12 bg-stone-400"></span>
          <span className="text-[10px] uppercase tracking-[0.3em] text-stone-400">
            Nørrebro, København
          </span>
        </div>
      </motion.div>
    </section>
  );
};

export default Hero;
